import { render, staticRenderFns } from "./LicensePlateForm.vue?vue&type=template&id=515cfe18&scoped=true"
import script from "./LicensePlateForm.vue?vue&type=script&lang=js"
export * from "./LicensePlateForm.vue?vue&type=script&lang=js"
import style0 from "./LicensePlateForm.vue?vue&type=style&index=0&id=515cfe18&prod&scoped=true&lang=css"
import style1 from "./LicensePlateForm.vue?vue&type=style&index=1&id=515cfe18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515cfe18",
  null
  
)

export default component.exports